import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearWelcomeMessage } from '../../../store/slices/authSlice';
import { showLoginWelcomeToast } from '../../../utils/loginWelcomeToast';

/**
 * Shows a one-time welcome toast after a successful login (all roles).
 * Mounted in Layout so every post-login destination is covered.
 */
const LoginWelcomeToast = () => {
  const dispatch = useDispatch();
  const { showWelcomeMessage, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!showWelcomeMessage || !user) return;

    showLoginWelcomeToast(user);
    dispatch(clearWelcomeMessage());
  }, [showWelcomeMessage, user, dispatch]);

  return null;
};

export default LoginWelcomeToast;
